import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CreateServiceOrderForm from '@/components/Services/ServiceOrders/CreateServiceOrderForm';

export default function ServiceOrderNewPage() {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate('/dashboard/services')}
        >
          <ArrowLeft className="w-4 h-4" />
        </Button>
        <div>
          <h1 className="text-xl font-semibold">Nova Ordem de Serviço</h1>
          <p className="text-sm text-muted-foreground">
            Preencha os dados para criar a OS
          </p>
        </div>
      </div>
      <CreateServiceOrderForm
        onSuccess={(id) => navigate(`/dashboard/services/${id}`)}
        onCancel={() => navigate('/dashboard/services')}
      />
    </div>
  );
}
